import React from "react";
import { CellProps } from "react-table";
import { Copies, useCopies } from "shared/hooks/useCopies";
import { ParticipantRole } from "shared/enums/ParticipantRole";
import NonAttendeeApplicationStatus from "shared/enums/NonAttendeeApplicationStatus";
import { ApiRegistrationParticipantForManagement } from "shared/types/ApiRegistrationParticipantForManagement";

export function getOrgAdminStatusCellValue(
  nonAttendeeApplicationStatus: NonAttendeeApplicationStatus,
  participantRoles: Array<ParticipantRole>,
  copies: Copies
) {
  if (nonAttendeeApplicationStatus === NonAttendeeApplicationStatus.ORG_ADMIN_APPLICATION_APPROVAL_PENDING) {
    return { value: copies.get("pending.approval"), className: "isPendingApproval" };
  } else if (participantRoles.includes(ParticipantRole.ORGANIZATION_ADMIN)) {
    return { value: copies.get("yes"), className: "yes" };
  } else {
    return { value: copies.get("no"), className: "no" };
  }
}

export default function OrgAdminStatusCell(props: CellProps<ApiRegistrationParticipantForManagement>) {
  const copies = useCopies();

  const cellValue = React.useMemo(
    () =>
      getOrgAdminStatusCellValue(
        props.row.original.nonAttendeeApplication?.status,
        props.row.original.participantRoles,
        copies
      ),
    [copies, props.row.original.nonAttendeeApplication?.status, props.row.original.participantRoles]
  );

  return (
    <div className="manageOrgAdmin_tableActions">
      <span className={cellValue.className}>{cellValue.value}</span>
    </div>
  );
}
